import { Container, Heading, Text } from '@chakra-ui/react';
import { ReactNode, FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';

interface IGradientBannerProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export const GradientBanner: FC<IGradientBannerProps> = ({ title, subtitle, action }) => {
  return (
    <Section variant="banner" textAlign="center">
      <Container>
        <Heading
          maxW={['full', null, 80, '32rem']}
          mx="auto"
          fontSize={['3xl', null, null, '5xl']}
          mt={[14, null, 20]}
          mb={subtitle ? [6, null, 8, 6] : [12, null, '4.5rem', 14]}
        >
          {title}
        </Heading>
        {subtitle && (
          <Text
            maxW={['full', null, '32rem', '45rem']}
            mb={[12, null, '4.5rem', '3.75rem']}
            mx="auto"
            fontSize={[null, null, null, '1.25rem']}
            lineHeight={[null, null, null, '1.75rem']}
          >
            {subtitle}
          </Text>
        )}
        {action}
      </Container>
    </Section>
  );
};
